import React from "react";

const Footer = () => {
  return (
    <div className="w-full h-35 bg-dark-blue-2 flex items-center justify-center">
      <p className="text-white ">Copyright@2024 All Rights Reserved</p>
    </div>
  );
};

export default Footer;
